import React, {Component} from 'react';
import {NavLink} from 'react-router-dom'
import Card, {
    CardPrimaryContent,
    // CardMedia,
    CardActions,
    CardActionButtons,
    // CardActionIcons
  } from "@material/react-card";
  import {
  
    Headline5,
    Headline6,
    Body2
 
} from '@material/react-typography';
import PaperButton from '@material/react-button';
import dashboardData from '../../data/dashboard_data.json';
import {ThemeContext} from '../../themeContext';

import routes from '../../routes'
import './Home.scss';
class Home extends Component {

    constructor(props) {
        super(props)
      //  console.dir(props)
  
        this.dimensions = {
            
           
            roleDesciption: {
                designer: 'Designer',
                analyst: 'Analyst',
                developer: 'Developer',
                scientist: 'Scientist',
                engineer: 'Engineer',
                student: 'Student',
                leadership: 'Leadership (Manager, Director, VP, etc)',
                academic: 'Academic',
                none_of_these_describe_my_role: 'None of these describe my role'
            },
            hiringPurpose: {
                "partlyDataviz": "Data visualization is only part of my job",                
                "doDataviz": "Hired to do data visualization"
            }
        }

        this.dimensionLabels = {
            roleDesciption: "Role Description",
            hiringPurpose: "Hiring Purpose",
            // workFocus: "Work Focus",
            // employmentStatus: "Are you a Freelancer"
        }

        // this.variableOfInterest = {
        //     name: "dataVizPresentation",
        //     categories:  [
        //         'Embedded in a tool', 
        //         'Dashboard', 
        //         'Scrollytelling', 
        //         'Static Web Page', 
        //         'Documents', 
        //         'Presentations', 
        //         'Newspaper or other physical handout', 
        //         'Mobile App', 
        //         'Interactive Notebook'
        //     ]
        // }

        this.variableOfInterest = {
            name: "workAmtDone",
            categories: [
                "More",
                "Less",
                "About as much as I expected for this role"
            ]
        }

        this.variableOfInterest2 = {
            name: "roleDesciption",
            categories: [
                    "Designer",
                    "Analyst",
                    "Developer",
                    "Scientist",
                    "Engineer",
                    "Student",
                    "Leadership (Manager, Director, VP, etc)",
                    "Academic",
                    "None of these describe my role"
            ]
        }

        this.variableOfInterest3 = {
           name: "hiringPurpose",
           categories: [
            "Data visualization is only part of my job",                
            "Hired to do data visualization"
           ]
        }

        // this.variableOfInterest4 = {
        //     name: "hiringPurpose",
        //     categories: [
        //      "Data visualization is only part of my job",                
        //      "Hired to do data visualization"
        //     ]
        //  }

        this.dimensions2 = {
            workAmtDone: {
                more: 'More',
                less: 'Less',
                moreorless: "About as much as I expected for this role"
            }
        }

        this.dimensionLabels2 = {
            workAmtDone: "Work Done",
           // hiringPurpose: "Hiring Purpose",
        }

      
    }

    componentDidMount() {

    }

    _computeUrl(dashboardPath, dashboardObj) {

        if (!dashboardPath || !dashboardObj) return '';
       //  let newPath = null;
        const firstColonIdx = dashboardPath.indexOf(':');
        if (firstColonIdx !== -1) {
            let pathWithoutParams = dashboardPath.substring(firstColonIdx, -1)   
             return  `${pathWithoutParams}${dashboardObj.category}/${dashboardObj.name}`
            // return  `${pathWithoutParams}${dashboardObj.name}`  
  
        }else {
            return ''
        }
      }

      _getDashboardCategory(category) {
          if (category === 'nps') return 'Net Promoter Score'
          if (category === 'ram' || category === 'top-n-ram') return 'Rank and Magnitude'
          //if (category === 'x') return 'Dashboard'
      }
    
    render() {
        
        const theme = this.context.theme;
        //console.dir(theme)

        let containerStyle = {
            background: theme.background
        }
       
        return(
            <div className="home-container" style={containerStyle}>
               <div className="home-intro">
                    <Headline5 className="headline5">Welcome to Surveez</Headline5>
                    <Body2 className="body2"> 
                                         Surveez provides a collection of dashboards that allows you to visualize, explore and 
                                         gain insights from the 2019 data visualization survey data
                    </Body2>  
                </div>
                <main className="home-main">                                                             
                    { 
                        dashboardData.map((dashboardObj, index)=>{                     
                            return     <NavLink key={index} className="nav-link" tabIndex="-1" activeClassName="active" to={this._computeUrl(routes.dashboard, dashboardObj)}>
                                            <Card className="home-dashboard-card">
                                            <CardPrimaryContent>
                                                    <Body2 className="body2">{this._getDashboardCategory(dashboardObj.category)} Dashboard</Body2>
                                                    <Headline6 className="headline6">{dashboardObj.title}</Headline6>
                                                    <Body2 className="body2">{dashboardObj.insight}</Body2>                                             
                                                </CardPrimaryContent>                                         
                                                <CardActions className="card-actions">
                                                    <CardActionButtons>
                                                        <PaperButton dense className="home-paper-button">Discover Insights</PaperButton>                                                 
                                                    </CardActionButtons>
                                                </CardActions>
                                        </Card>
                                    </NavLink>
                        })
                    }
                </main>    
            </div>
        )
    }
}
Home.contextType = ThemeContext

export default Home;